<template>
  <div v-bind:class="{ 'v-overlay--active': value }" class="v-overlay">
    <div v-if="value" class="h-max">
      <div class="d-flex justify-center align-center h-max">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppOverlay',
  props: {
    value: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style scoped>
.v-overlay {
  position: absolute;
}
.h-max {
  height: 100%;
}
</style>
